import { TweenMax } from "gsap/all";

class CustomSelect {

    constructor(config){
        this.config = {
            selector: config ? (config.selector || ".productSelect") : ".productSelect",
            labelselector: config ? (config.labelselector || ".selected") : ".selected",
            expandableSelector: config ? (config.expandableSelector || "ul") : "ul",
            optionselector: config ? (config.optionselector || "ul li") : "ul li a",
            openclass: config ? (config.openclass || "productSelect--open") : "productSelect--open",
            realselect: config ? (config.openclass || "select") : "select",
        };
        this.realSelect = document.querySelector(this.config.realselect);
        this.target = document.querySelector(this.config.selector);
        this.label = this.target.querySelector(this.config.labelselector);
        this.options = this.target.querySelectorAll(this.config.optionselector);
        this.expandable = this.target.querySelector(this.config.expandableSelector);
        
        //allow removelistener on binded function
        this.clickOutsideBinded = this.outsideClickListener.bind(this);

        //add events
        this.addEvents();
    }

    addEvents(){
        this.label.addEventListener("click", e => {
            this.open = this.open ? false : true;
            e.preventDefault();
        })
        this.options.forEach(element => {
            element.addEventListener("click", e => {
                this.clickItem(e.target);
                e.preventDefault();
            })
        });
    }

    //getter and setter for open prop
    set open(value){
        this.target.classList.toggle(this.config.openclass, value);
        if(value){
            document.addEventListener('click', this.clickOutsideBinded, true)
            TweenMax.to(this.expandable, 0.4, {height:"auto"});
        }else{
            document.removeEventListener('click', this.clickOutsideBinded, true)
            TweenMax.to(this.expandable, 0.4, {height:0});
        }
    }
    get open(){
        return this.target.classList.contains(this.config.openclass);
    }

    //click on the label
    clickLabel(){
        this.open = true;
    }

    //clicks on items
    clickItem(item){
        this.realSelect.value = item.getAttribute("value");
        this.realSelect.dispatchEvent(new Event('change'));
        this.open = false;
        this.label.innerHTML = item.innerHTML;
    }

    // detects clicks outside
    outsideClickListener(event){
        if (!this.target.contains(event.target)){
            this.open = false;
        }
        event.preventDefault();
    }
}
export default CustomSelect;